import { ErrorInStore } from 'containers/Static/Error/index.store'
import wrappers from 'routing/wrappers'

export const errorPage = [
	{
		component: wrappers(ErrorInStore),
	},
]
